import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn"    //使用中文，分页组件

import * as ECharts from 'echarts';
import 'echarts-gl';
const app = createApp(App);
// 全局注册echarts
app.config.globalProperties.$echarts = ECharts;

import "./assets/css/common.css"  //公共样式

createApp(App).use(store).use(router).use(ElementPlus,{locale:zhCn}).mount('#app')
